import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-16">
          <Breadcrumb
            items={[
              { name: '首页', path: '/' },
              { name: '关于我们' },
            ]}
          />

          <main className="w-full">
            <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
              <div className="max-w-4xl mx-auto text-center">
                <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-5">
                  关于51黑料
                </h1>
                <p className="text-foreground-600 leading-relaxed text-sm md:text-base max-w-2xl mx-auto">
                  51黑料网成立于2020年，是国内领先的娱乐资讯平台。我们致力于为广大用户提供最新、最全、最真实的娱乐八卦、明星爆料、网红热点及社会事件深度揭秘内容。51黑料坚持独立、客观的报道立场，以专业的态度和敏锐的洞察力，为用户呈现娱乐圈的真实面貌。
                </p>
              </div>
            </section>

            <section className="w-full px-4 md:px-6 py-14">
              <div className="max-w-4xl mx-auto">
                <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
                  品牌故事
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                      我们的起源
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      51黑料网诞生于互联网内容蓬勃发展的时代。创始团队由一群热爱娱乐行业、关注社会热点的资深媒体人组成。我们发现，在信息爆炸的时代，用户需要的不仅仅是快速的信息传递，更需要真实、有深度、有态度的内容服务。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      基于这一理念，51黑料网应运而生。我们从一开始就确立了"真实、快速、深度"的核心价值观，坚持为用户提供高质量的娱乐资讯内容。
                    </p>
                  </div>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                      我们的使命
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      51黑料网的使命是成为用户获取娱乐资讯的首选平台。我们不仅关注明星八卦和娱乐新闻，更致力于挖掘事件背后的社会意义，为用户提供有价值的阅读体验。
                    </p>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      我们相信，好的资讯内容应该兼具娱乐性和思想性。在为用户带来快乐和谈资的同时，也能引发思考，传递积极的价值观。
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="w-full px-4 md:px-6 py-14 bg-background-100">
              <div className="max-w-4xl mx-auto">
                <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
                  品牌信誉
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                  {[
                    { number: '500万+', label: '月活跃用户' },
                    { number: '50万+', label: '日均阅读量' },
                    { number: '10万+', label: '累计爆料文章' },
                    { number: '99.7%', label: '内容准确率' },
                  ].map((stat, index) => (
                    <div key={index} className="text-center p-6 bg-background-50 rounded-lg border border-background-200">
                      <div className="font-heading text-3xl font-bold text-primary-500 mb-2">
                        {stat.number}
                      </div>
                      <div className="text-sm text-foreground-600">
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
                  {[
                    {
                      icon: 'ri-award-line',
                      title: '行业认可',
                      desc: '51黑料网多次获得行业媒体评选的新锐资讯平台奖项，我们的报道质量和专业态度得到了业内外的广泛认可。',
                    },
                    {
                      icon: 'ri-shield-star-line',
                      title: '用户信赖',
                      desc: '凭借真实可靠的资讯内容，51黑料网在用户中建立了良好的口碑。我们始终坚持对每一条信息负责的原则。',
                    },
                    {
                      icon: 'ri-team-line',
                      title: '专业团队',
                      desc: '我们拥有一支由资深媒体人、专业编辑和调查记者组成的核心团队，确保内容的高质量和高水准。',
                    },
                  ].map((item, index) => (
                    <div key={index} className="p-6 bg-background-50 rounded-lg border border-background-200">
                      <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-4">
                        <i className={`${item.icon} text-primary-500 text-xl`}></i>
                      </div>
                      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>

            <section className="w-full px-4 md:px-6 py-14">
              <div className="max-w-4xl mx-auto">
                <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
                  联系我们
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
                      联系方式
                    </h3>
                    <div className="space-y-4">
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                          <i className="ri-mail-line text-primary-500"></i>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                          <p className="text-sm text-foreground-600">contact@51heilia.com</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                          <i className="ri-phone-line text-primary-500"></i>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-800">客服电话</p>
                          <p className="text-sm text-foreground-600">400-888-5151</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                          <i className="ri-map-pin-line text-primary-500"></i>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-800">公司地址</p>
                          <p className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                          <i className="ri-time-line text-primary-500"></i>
                        </div>
                        <div>
                          <p className="text-sm font-medium text-foreground-800">工作时间</p>
                          <p className="text-sm text-foreground-600">周一至周五 9:00 - 18:00</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ContactForm />
                </div>
              </div>
            </section>

            <section className="w-full px-4 md:px-6 py-14 bg-background-100">
              <div className="max-w-4xl mx-auto">
                <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-8 text-center">
                  加入我们
                </h2>
                <p className="text-center text-foreground-600 text-sm mb-8 max-w-2xl mx-auto">
                  51黑料网正在快速发展中，我们诚邀有才华、有激情的内容创作者加入我们的团队。如果你热爱娱乐行业，对资讯内容有独到的见解，欢迎联系我们。
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                  {[
                    { icon: 'ri-pencil-line', title: '内容编辑', desc: '负责娱乐资讯的采编与审核' },
                    { icon: 'ri-search-eye-line', title: '调查记者', desc: '深入挖掘娱乐圈背后的故事' },
                    { icon: 'ri-smartphone-line', title: '新媒体运营', desc: '负责社交媒体内容运营与推广' },
                  ].map((job, index) => (
                    <div key={index} className="p-5 bg-background-50 rounded-lg border border-background-200 text-center">
                      <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-lg bg-secondary-100">
                        <i className={`${job.icon} text-secondary-600 text-lg`}></i>
                      </div>
                      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                        {job.title}
                      </h3>
                      <p className="text-xs text-foreground-600">
                        {job.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </main>
        </div>

        <Footer />
      </div>
    </>
  );
}

function ContactForm() {
  return (
    <div>
      <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-4">
        在线留言
      </h3>
      <form
        data-readdy-form
        action="https://readdy.ai/api/form/d9oprbiqs38sj6jc7d8g"
        method="POST"
        className="space-y-4"
        onSubmit={async (e) => {
          e.preventDefault();
          const form = e.currentTarget;
          const formData = new FormData(form);
          const honeypot = formData.get('phone_alt') as string;
          if (honeypot && honeypot.trim() !== '') return;

          try {
            const res = await fetch(form.action, {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
            });
            const text = await res.text();
            let parsed;
            try { parsed = JSON.parse(text); } catch { parsed = null; }
            if (res.ok && parsed?.code === 'OK') {
              alert('留言提交成功！我们会尽快与您联系。');
              form.reset();
            } else {
              const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
              alert(msg);
            }
          } catch {
            alert('网络错误，请稍后重试');
          }
        }}
      >
        <input
          type="text"
          name="phone_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
          className="spam-guard-field"
        />
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
            姓名
          </label>
          <input
            type="text"
            id="contact-name"
            name="name"
            required
            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
            邮箱
          </label>
          <input
            type="email"
            id="contact-email"
            name="email"
            required
            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            placeholder="请输入您的邮箱"
          />
        </div>
        <div>
          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
            留言内容
          </label>
          <textarea
            id="contact-message"
            name="message"
            rows={4}
            maxLength={500}
            required
            className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
            placeholder="请输入您的留言内容（500字以内）"
          ></textarea>
        </div>
        <button
          type="submit"
          className="w-full px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          提交留言
        </button>
      </form>
    </div>
  );
}